import isEmpty from "../../is-empty/catalog-item";

export default function(value) {
  return !isEmpty(value);
}
